import React, { FC } from 'react';
import { Box, Chip, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { User } from 'models/user';

type DentistSettingsHeaderProps = {
    dentist: User;
};
const DentistSettingsHeader: FC<DentistSettingsHeaderProps> = ({ dentist }: DentistSettingsHeaderProps) => {
    const { t: translate } = useTranslation('client-directory');

    return (
        <Box p={2}>
            <Box mb={1} display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                    <Typography variant="h1">{dentist?.fullName}</Typography>
                </Box>
                <Box display="flex" alignItems="center">
                    <Box mr={1}>
                        <Typography color="gray" variant="caption">
                            {dentist?._id}
                        </Typography>
                    </Box>
                    <Chip
                        label={
                            dentist.local
                                ? translate('client-directory:MY_DENTIST')
                                : translate('client-directory:DENTHUB_CONNECTED_DENTIST')
                        }
                        size="medium"
                        color={dentist.local ? 'info' : 'secondary'}
                    />
                </Box>
            </Box>
            <Divider />
        </Box>
    );
};

export default DentistSettingsHeader;
